import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { TextFieldPlaceholder } from "../../../Forms/TextFieldPlaceholder";
import { Edc } from "../../Edc";
import { useGoogleMapsModal } from "../../../GoogleMaps/useGoogleMapsModal";
import { OpenGoogleMapsIconButton } from "../../../GoogleMaps/OpenGoogleMapsIconButton";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

export const EdcCoordinatesForm = ({ disabledFields }: MdmFormProps) => {
  const {
    control,
    formState: { disabled: isFormDisabled },
  } = useFormContext<Edc>();
  const { googleMapsModal, openGoogleMapsModal } = useGoogleMapsModal<Edc>("Latitude", "Longitude");

  return (
    <BorderedFormGrid>
      {googleMapsModal}
      <Grid item xs={12}>
        <TextFieldInput
          name="Latitude"
          control={control}
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="Longitude"
          control={control}
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="MgLatitude"
          control={control}
          label="M&G Latitude"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="MgLongitude"
          control={control}
          label="M&G Longitude"
          disabledFields={disabledFields}
        />
      </Grid>
      {/* PLACEHOLDER */}
      <Grid item xs={12}>
        <TextFieldPlaceholder />
      </Grid>
    </BorderedFormGrid>
  );
};
